import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { connect } from 'react-redux';
import { secondaryMarketRtFormClientSelectedThunk } from 'state/secondaryMarket/realtimeQuote';
import { secondaryMarketRtFormFieldChanged } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import { getSecondaryMarketRtFormClient } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import {
  getSecondaryMarketAstroProductClients,
  getSecondaryMarketRealtimeAstroProductFromTab,
} from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';
import type { LoadingStatus } from 'utils/status';

import { ClientSelector } from '../shared/components/clientSelectors';

type OwnProps = Readonly<{
  tabId: string;
  getErrors?: (item: ISalesCounterpart) => string[];
}>;

type StateProps = {
  loadingStatus: LoadingStatus;
  productClients?: ReadonlyArray<ISalesCounterpart>;
  selectedClient?: ISalesCounterpart;
  isDisabled?: boolean;
};

type DispatchProps = Readonly<{
  onClientChanged: (client: ISalesCounterpart) => void;
  onClientClear: () => void;
}>;

export type ClientSelectorProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const isin = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId)?.data?.isin;
  const astroProductClients = isin !== undefined ? getSecondaryMarketAstroProductClients(state, isin) : [];
  const selectedClient = getSecondaryMarketRtFormClient(state, tabId);
  const frozen = getTabIsFrozen(state, tabId) ?? false;
  return {
    loadingStatus: 'success',
    selectedClient,
    productClients: astroProductClients,
    isDisabled: frozen,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps =>
  ({
    onClientChanged: (client: ISalesCounterpart) => {
      dispatch(secondaryMarketRtFormClientSelectedThunk(tabId, client));
    },
    onClientClear: () => {
      dispatch(secondaryMarketRtFormFieldChanged(tabId, 'client', undefined));
    },
  }) as DispatchProps;

const connectClientSelector = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedClientSelector = connectClientSelector(ClientSelector);
ConnectedClientSelector.displayName = 'ConnectedClientSelector';
